import React, { useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap';

import { useRecorded } from 'hooks/modal/index';
import { closeRecorded } from 'store/modal/index';

import ListTableRow from 'components/Table/ListTableRow';
import RecordedItem from './RecordedItem';

const ModalRecorded = () => {
  const dispatch = useDispatch();
  const recorded = useRecorded();
  const { isOpen, data, title } = recorded;

  const thead = ['No', 'Link', 'Size', 'Date', 'Action'];

  const filterfiles = data?.flatMap(
    (it) =>
      it.playback?.recording_files?.filter(
        (file) =>
          file.file_extension === 'MP4' &&
          file?.recording_type?.startsWith('shared_screen_with_speaker_view'),
      ) ?? [],
  );

  const orderByMeetingId = useMemo(() => {
    const meetingIds = new Map();
    return filterfiles?.map((item) => {
      if (meetingIds.has(item?.meeting_id)) {
        meetingIds.set(item?.meeting_id, [
          ...meetingIds.get(item?.meeting_id),
          item?.id,
        ]);
      } else {
        meetingIds.set(item?.meeting_id, [item?.id]);
      }
      const getIds = meetingIds.get(item?.meeting_id);
      return {
        ...item,
        order: meetingIds.size,
        siblingRecordIndex: getIds.length - 1,
      };
    });
  }, [filterfiles]);

  const handleClose = () => dispatch(closeRecorded());

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      className="modal-lg modal-dialog-centered"
      contentClassName="p-0"
    >
      <ModalHeader toggle={handleClose}>
        <span className="sub-heading_text_title">{title}</span>
      </ModalHeader>
      <ModalBody className="flex-grow-1 pb-sm-0 pb-3">
        <div className="overflow-x-auto">
          <Table className="table-header-custom" responsive>
            <thead>
              <tr>
                {thead.map((item, index) => (
                  <th
                    className={
                      thead?.length - 1 > index ? 'text-left' : 'text-left'
                    }
                    key={index}
                  >
                    {item}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <ListTableRow length={data?.length} col={thead.length}>
                {orderByMeetingId.map((record, index) => (
                  <RecordedItem
                    key={record?.id}
                    index={index}
                    order={record.order}
                    record={record}
                    siblingRecordIndex={record?.siblingRecordIndex}
                  />
                ))}
              </ListTableRow>
            </tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalRecorded;
